<template>
  <section id="empresas">
    <div>
      <h3>
        Empresas, Organismos y Municipios que lo están usando:
      </h3>

      <div class="mt-5">
        <BrandSlider :logos="slider1" :speed="50" />
        <BrandSlider :logos="slider2" direction="right" :speed="155" />
        <BrandSlider :logos="slider3" :speed="47" />
      </div>
    </div>
  </section>
</template>

<script>
import BrandSlider from "./BrandSlider.vue";

export default {
  name: "Empresas",
  components: { BrandSlider },
  data() {
    return {
      slider1: [
        "/assets/img/home/aosc.webp",
        "/assets/img/home/recursos-naturales.webp",
        "/assets/img/home/ministerio.webp",
        "/assets/img/home/rentas.webp",
        "/assets/img/home/dpec.webp",
        "/assets/img/home/invico.webp",
        "/assets/img/home/cultura.webp",
        "/assets/img/home/unne.webp",
        // agrega más rutas de logos
      ],
      slider2: [
        "/assets/img/home/bellavista.webp",
        "/assets/img/home/caacati.webp",
        "/assets/img/home/corrientes.webp",
        "/assets/img/home/curuzu.webp",
        "/assets/img/home/goya.webp",
        "/assets/img/home/itati.webp",
        "/assets/img/home/ituzaingo.webp",
        "/assets/img/home/lavalle.webp",
        "/assets/img/home/montecaseros.webp",
        "/assets/img/home/paso.webp",
        "/assets/img/home/riachuelo.webp",
        "/assets/img/home/saladas.webp",
        "/assets/img/home/sancarlos.webp",
        "/assets/img/home/sauce.webp",
        "/assets/img/home/santotome.webp",
        "/assets/img/home/virasoro.webp",

        // agrega más rutas de logos
      ],
      slider3: [
        "/assets/img/home/blinker.webp",
        "/assets/img/home/boca-unidos.webp",
        "/assets/img/home/colegio-escribanos.webp",
        "/assets/img/home/viking.webp",
        "/assets/img/home/ciencias-economicas.webp",

        // agrega más rutas de logos
      ],
    };
  },
};
</script>

<style scoped>
/* EMPRESAS  */
#empresas {
  color: #00b1eb;
  text-align: center;
  background: #fff;
  margin-top: -280px;
  position: relative;
  z-index: 1000;
  padding-top: 50px;
}

.empresas-image {
  max-width: 100%;
  margin: auto;
}

h3 {
  font-weight: bold;
  font-size: 35px;
}

@media (max-width: 1550px) {
  .empresas-image {
    padding: 0 12%;
  }
}

@media (max-width: 1280px) {
  #empresas {
    margin-top: -220px;
  }

  h3 {
    font-size: 25px;
  }
}

@media (max-width: 1024px) {
  #empresas {
    margin-top: -180px;
  }

  h3 {
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  #empresas {
    margin-top: -60px;
    padding: 0 6%;
    padding-top: 10px;
  }

  .empresas-image {
    padding: 0%;
  }
}

@media (max-width: 600px) {
  h3 {
    font-size: 16px;
    padding: 0 8%;
  }
}
</style>
